"use strict";
/** @module utils */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Debouncer = void 0;
/**
 * Class that holds the Debouncer methods.
 */
var Debouncer = /** @class */ (function () {
    function Debouncer(onApply, debounceTime) {
        this.onApply = onApply;
        this.debounceTime = 300;
        this.debounceTimer = null;
        if (debounceTime != null) {
            this.debounceTime = debounceTime;
        }
    }
    /**
     * Post Update method
     */
    Debouncer.prototype.postUpdate = function () {
        var _this = this;
        if (this.debounceTimer != null) {
            clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = window.setTimeout(function () {
            _this.onApply();
        }, this.debounceTime);
    };
    return Debouncer;
}());
exports.Debouncer = Debouncer;
//# sourceMappingURL=debouncer.js.map